import React from 'react'
import { connect } from 'react-redux';
import { getSecurity } from "../actions/securityActions";
import { getSiteConfidentialityLevels, getSiteQuotas, getSiteLocations } from "../actions/appActions";
import { Spinner, SpinnerSize } from '@fluentui/react';

class Startup extends React.Component
{
    constructor(props) {
        super(props);

        this.state = {
            appInitialized: false
        }
    }

    componentDidMount(): void {
        Promise.all([
            this.props.getLevels(),
            this.props.getSiteConfidentialityLevels(),
            this.props.getSiteQuotas(),
            this.props.getSiteLocations()
        ]).then(() => {
            this.setState({ appInitialized: true});
        })
    }

    render() {
        return this.props.error 
            ? <span className='errorMessage'>{this.props.errorMessage}</span> 
            : this.state.appInitialized
                ? this.props.children
                : <Spinner style={{padding: '200px'}} size={SpinnerSize.large} />
    }
}

const mapActionsToProps = {
    getLevels : getSecurity,
    getSiteConfidentialityLevels,
    getSiteQuotas,
    getSiteLocations
}

const mapStateToProps = state => ({
    error: state.response.error,
    errorMessage: state.response.errorMessage
})

export default connect(mapStateToProps, mapActionsToProps)(Startup)



// WEBPACK FOOTER //
// ./src/Startup/Startup.js